import axios from 'axios';
import configData from './dashboardDara.json';
import {setToken,getToken,removeToken} from "./authToken"


export default async function request(path, data, method) {
    const token = getToken();
        
    let config = {
        method: method,
        url: `${configData.url}/app/${path}`,
        // url: `https://atia.genuisweb.com/app/${path}`,
        // url: `http://localhost:4004/app/${path}`,

        headers: {
            'Content-Type': 'application/json',
            'authorization': token || ""  // Use Authorization header for token
            // 'Cookie': token || "" 
        },
        data: data,
    };

    return axios.request(config)
        .then((response) => {
            console.log(response)
            return response;
        })
        .catch((error) => {
            console.log("error");
            console.log(error);
            return error.response;
        });
}
